import { cleanObjectWithUndefinedProperties } from './cleanObjectWithUndefinedProperties';

export const generateParams = (params: any) => {
  cleanObjectWithUndefinedProperties(params);
  const _params = new URLSearchParams(params);

  return _params.toString();
};
